// admin-passkey-login: the browser side of signing in with a chat account's passkey.
// aveq-admin relays to aveq-agent, which checks it; this only converts between the
// JSON (base64url) and the ArrayBuffers navigator.credentials works in.

export const toBytes = (b64u) => {
  const b64 = b64u.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - (b64u.length % 4)) % 4);
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
};

export const toB64u = (buf) => {
  let bin = '';
  new Uint8Array(buf).forEach((b) => { bin += String.fromCharCode(b); });
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

export const passkeySupported = () =>
  typeof window !== 'undefined' && !!window.PublicKeyCredential
  && typeof navigator !== 'undefined' && !!navigator.credentials;

// The person closed the browser's passkey dialog: not an error to show.
export const isCancel = (e) => e && (e.name === 'NotAllowedError' || e.name === 'AbortError');

// Resolves to the /auth/passkey/verify (or /options) Response, or null if the browser
// had no passkey to offer.
export async function passkeySignIn() {
  const o = await fetch('/auth/passkey/options', { method: 'POST', credentials: 'same-origin' });
  if (!o.ok) return o;
  const { challenge_id: challengeId, options } = await o.json();
  const cred = await navigator.credentials.get({
    publicKey: {
      ...options,
      challenge: toBytes(options.challenge),
      allowCredentials: (options.allowCredentials || []).map((c) => ({ ...c, id: toBytes(c.id) })),
    },
  });
  if (!cred) return null;
  const r = cred.response;
  return fetch('/auth/passkey/verify', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      challenge_id: challengeId,
      credential: {
        id: cred.id, rawId: toB64u(cred.rawId), type: cred.type,
        response: {
          clientDataJSON: toB64u(r.clientDataJSON),
          authenticatorData: toB64u(r.authenticatorData),
          signature: toB64u(r.signature),
          userHandle: r.userHandle ? toB64u(r.userHandle) : null,
        },
        clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
      },
    }),
  });
}
